import { useContext } from "react"
import { ConfigurationContext } from "../../context/configurationContext"
import { useNavigate } from "react-router-dom";

const InterceptorRequiereLogin = ({children, path}) => {
    var navigate = useNavigate();
    const {menu} = useContext(ConfigurationContext);
    const autenticado = localStorage.getItem('autenticado');
    const opcion = menu.filter(m=>m.url === path)[0];
    if (opcion){
      const requireLogin = opcion.requireLogin;
      if (requireLogin && autenticado == 'false'){
        navigate('login', { replace: true})
        return <></>
      }
    }

    const opcionChildren = menu.filter(m=>m.children.filter(c=>c.url === path))[0];
    if (opcionChildren){
        const opcion =  opcionChildren.children[0];
        if (opcion){
            if (opcion.requireLogin && autenticado == 'false' ){
                navigate('login')
                return <></>
            }
        }
    }

    if (menu.length === 0){
        navigate('login', { replace: true})
        return <></>
    }


    return children
}

export default InterceptorRequiereLogin